interface LocaleModule {
  default: Record<string, string>;
}

// Lazy loader for every locale JSON shipped in this package, derived from the
// translation files themselves so adding or removing a locale needs no change
// here. Keyed by the bundler-relative path (e.g. '../translations/fr.json').
const localeModules = import.meta.glob('../translations/*.json') as Record<string, () => Promise<LocaleModule>>;

const languageCodeOf = (path: string): string => path.slice(path.lastIndexOf('/') + 1, -'.json'.length);

/** Lazy loaders keyed by language code (e.g. 'fr', 'pt-PT'). */
export const localeLoaders: Record<string, () => Promise<LocaleModule>> = Object.fromEntries(
  Object.entries(localeModules).map(([path, loader]) => [languageCodeOf(path), loader]),
);

/** Language codes for every locale JSON shipped in this package, sorted. */
export const supportedLanguages = Object.keys(localeLoaders).sort();

/**
 * Maps an API-provided locale code to a supported language, falling back to the
 * closest base language (e.g. `pt-BR` → `pt`) or `en` when there is no match.
 */
export const matchApiLanguageToTranslationFile = (localeCode: string): string => {
  if (!localeCode.includes('-')) {
    return supportedLanguages.includes(localeCode) ? localeCode : 'en';
  }
  if (supportedLanguages.includes(localeCode)) {
    return localeCode;
  }
  const base = localeCode.split('-')[0];
  return supportedLanguages.includes(base) ? base : 'en';
};
